export const locale = {
    lang: 'en',
    data: {
        LV_TASK: {
            TITLE: 'Tasks',
            SEARCH_LABEL: 'Search for a task',
            ALL: 'All',
            ACTIVE: 'Active',
            OVERDUEDATE: 'Overdue',
            COLUMNS: {
                TITLE: 'Task',
                DUEDATE: 'Duedate',
                STATUS: 'Status',
                TASK: 'Task',
                ASSIGNED: 'Assigned to',
                PROJECT: 'Project',
                DESCRIPTION: 'Description',
                KIND: 'Taskkind',
                WORKPACKAGE: 'Workpackage',
                START: 'Start',
                PRIORITY: 'Priority',
                HIGH: '(1) High',
                NORMAL: '(2) Normal',
                LOW: '(3) Low',
                NOTSTARTED: 'Not started',
                INPROCESSING: 'In processing',
                COMPLETED: 'Completed',
                RESET: 'Reset',
                WAITING: 'Waiting',
                TYPE: 'Tasktype',
                MARK: 'Mark',
                CRITICAL: 'Critical',
                UNCRITICALLY: 'Uncritically',
                PROCESSSTEP: 'Processstep',
                ANSPRECHPARTNER: 'Ansprechpartner'
            },
            NEW: 'New task',
            EDIT: 'Edit task',
            SAVE: 'Save',
        },
    },
};
